export enum SocialButtonType
{
    Like = "like",
    Comment = "comment",
    Share = "share",
}
